import React, { Component } from "react";
import { applyDataTable } from '../../custom/dataTable';
import Delete from '../../../assets/img/svg/delete.svg';
import del from "../../../assets/img/svg/Del.svg";
import $ from 'jquery';
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import styles from "../../../assets/jss/customStyle";
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import moment from "moment"
import axios from "axios";
import API from "../../../_helpers/endpointService";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { CssTextField, CssTextFieldLast, CssTextFieldRow } from "../../custom/textField"
import Select from "react-select";
import closeIcon from "../../../assets/img/svg/closeIcon.svg";
import { roleTypeString, additionalRoles, additionalRole, yardCommonRoles, yardCommonRole, yardOwnerRole, adminRole, additionalTraining, additionalTrainings, yardMandatoryTraining, yardMandatoryTrainings, shipOwnerRole } from "../../common/commonJson";
import { characterValidation, dropDownOptions, dropDownOptionsTrainings } from "../../common/commonFunction";
import yardIcon from "../../../assets/img/svg/yardRolesIcon.svg";

class YardTrainings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            render: false,
            dataList: [],
            deleteId: 0,
            showrow: false,
            responseId: 0,
            index: 0,
            actNameFocus: false,
            DescNameFocus: false,
            name: "",
            typeId: [],
            nameError: false,
            searchData: {
                PageNumber: 1,
                PageSize: 100,
            },
            searchCommonData: {
                PageNumber: 1,
                PageSize: 100,
            },
            lookupData: {
                Name: "",
                PageNumber: 1,
                PageSize: 1000000,
            },
            rolesValue: [],
            trainingsOptions: [],
            FocusId: 0,
            FocusId1: 0,
            YardId: 0,
            dataListCommon: [],
            trainingsDisplay: [],
            HoverIdCommon: 0,
            FocusIdCommon: 0,
            isDisabled: false,
            trainingChange: false,
            paging: false,
            existId: [],
            isOnChange: false,
        }
    }

    componentDidMount() {
        const { dispatch } = this.props;
        const userRole = localStorage.getItem("UserRoles");
        this.setState({
            isDisabled: (userRole == shipOwnerRole) ? true : false
        })
        this.setState({
            YardId: localStorage.getItem("YardId") ? localStorage.getItem("YardId") : 0,
            paging: true,
        }, () => {
            // this.lookupRoleData(this.state.lookupData, roleTypeString);
            this.dataTableAdditionalTrainings(this.state.searchData);
            this.getYardAdditionalRoles(this.state.lookupData);
            this.getYardCommonRoles(this.state.lookupData);
            this.dataTableMandatoryTrainings(this.state.searchCommonData);
        })
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }

    getYardAdditionalRoles = (data) => {
        let apiUrl = API.ACTION_YARDROLES + this.state.YardId + additionalRoles + '?PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    response.data?.AdditionalRoles?.map((r) => (
                        r.YardAdditionalRoles = true
                    ))
                    if (this.state.trainingsDisplay?.length == 0) {
                        const data = response.data?.AdditionalRoles?.filter((role) => role.Name !== "");
                        this.setState({
                            trainingsDisplay: data
                        })
                        this.setState({
                            trainingsOptions: dropDownOptionsTrainings(data)?.props?.children
                        })
                    } else {
                        let data = this.state.trainingsDisplay;
                        response.data?.AdditionalRoles?.map((r) => (
                            r.Name != "" ? data.push(r) : ""
                        ))
                        this.setState({
                            trainingsDisplay: data
                        })
                        this.setState({
                            trainingsOptions: dropDownOptionsTrainings(data)?.props?.children
                        })
                    }
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    getYardCommonRoles = (data) => {
        let apiUrl = API.ACTION_YARDROLES + this.state.YardId + yardCommonRoles + '?PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    response.data?.YardCommonRoles?.map((r) => (
                        r.YardAdditionalRoles = false
                    ))
                    if (this.state.trainingsDisplay?.length == 0) {
                        const data = response.data?.YardCommonRoles?.filter((role) => role.Name !== "");
                        this.setState({
                            trainingsDisplay: data
                        })
                        this.setState({
                            trainingsOptions: dropDownOptionsTrainings(data)?.props?.children
                        })
                    } else {
                        let data = this.state.trainingsDisplay;
                        response.data?.YardCommonRoles?.map((r) => (
                            r.Name != "" ? data.push(r) : ""
                        ))
                        this.setState({
                            trainingsDisplay: data
                        })
                        this.setState({
                            trainingsOptions: dropDownOptionsTrainings(data)?.props?.children
                        })
                    }
                    this.setState({})
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    dataTableAdditionalTrainings = (data) => {
        let apiUrl = API.ACTION_YARDTRAININGS + this.state.YardId + additionalTrainings + '?PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.dataList = [];
                    this.setState({})
                    response.data?.AdditionalTrainings?.map((r) => (
                        r?.ApplicableRoles?.map((i) => (
                            i.YardAdditionalRoles = false
                        )),
                        r?.YardRoles?.map((i) => (
                            i.YardAdditionalRoles = true
                        ))
                    ))
                    response.data?.AdditionalTrainings?.sort((a, b) => {
                        return a.Id - b.Id;
                    });
                    this.state.dataList = response.data;
                    const check = response.data?.AdditionalTrainings?.filter((data) => data.Title == "" && (data.ApplicableRoles?.length == 0 || data.ApplicableRoles?.length == undefined) && (data.YardRoles?.length == 0 || data.YardRoles?.length == undefined))
                    if (!this.state.isDisabled && check?.length == 0) {
                        this.state.dataList?.AdditionalTrainings?.push({
                            Id: 0,
                            Name: "",
                            TypeId: [],
                        })
                    }
                    this.state.render = true;
                    this.setState({})
                    if (this.state.paging == true) {
                        setTimeout(
                            // document.getElementById("additionalTrainings").scrollIntoView(),
                            window.scrollTo(0, 0)
                            , 0)
                        this.setState({
                            paging: false
                        })
                    }
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    dataTableMandatoryTrainings = (data) => {
        let apiUrl = API.ACTION_YARDTRAININGS + this.state.YardId + yardMandatoryTrainings + '?PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.dataListCommon = [];
                    this.setState({})
                    response.data?.MandatoryTrainings?.map((r) => (
                        r?.AdditionalRoles?.map((i) => (
                            i.YardAdditionalRoles = false
                        )),
                        r?.YardRoles?.map((i) => (
                            i.YardRoles = true
                        ))
                    ))
                    response.data?.MandatoryTrainings.sort((a, b) => {
                        return a.Id - b.Id;
                    });
                    this.state.dataListCommon = response.data;
                    this.state.dataListCommon?.MandatoryTrainings.push({
                        Id: 0,
                        Name: "",
                        TypeId: [],
                    })
                    this.setState({})
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                    if (this.state.paging == true) {
                        setTimeout(
                            document.getElementById("mandatoryTrainingsScroll").scrollIntoView(),
                            0)
                        this.setState({
                            paging: false
                        })
                    }
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    lookupRoleData = (data, type) => {
        let apiUrl = API.LOOKUP_DATA + '?Name=' + data.Name + '&Type=' + type + '&PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#Yardtrainings .MuiListItemText-primary").addClass("spanTopBar")
        $("#Trainings1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Trainings").addClass("d-none");
        $("#Trainings").removeClass("d-block");
        $("#YTrainings .MuiListItemText-primary").removeClass("fw-bolder");
        $("#YardTrainings").removeClass("active-color");
    }

    sidebar = () => {
        this.props.navigate("/sidebaryarddocument");
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#Yardtrainings .MuiListItemText-primary").addClass("spanTopBar")
        $("#Trainings1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Trainings").removeClass("d-none");
        $("#Trainings").addClass("d-block");
        $("#YTrainings .MuiListItemText-primary").addClass("fw-bolder");
        $("#YardTrainings").addClass("active-color");
    };

    post_data = (data) => {
        let apiUrl = API.ACTION_YARDTRAININGS + this.state.YardId + additionalTraining;
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.dataTableAdditionalTrainings(this.state.searchData);
                    let data1 = [];
                    let data2 = [];
                    let dataObj = {};
                    if (this.state.typeId?.length > 0) {
                        this.state.typeId?.map((r) => (
                            dataObj = {
                                RoleId: parseInt(r.value?.split(",")[0]),
                                RoleName: r.value?.split(",")[1]
                            },
                            r.role == true ? data1.push(dataObj)
                                : data2.push(dataObj)
                        ))
                    }
                    this.state.dataList?.AdditionalTrainings?.map((i) => (
                        i.Id == 0 ? (i.Id = response.data, i.Title = this.state.name, i.ApplicableRoles = data2, i.YardRoles = data1) : <></>
                    ))
                    this.setState({})
                    this.setState({
                        name: "",
                        typeId: [],
                    })
                    this.state.nameError = false;
                    this.state.FocusId = 0;
                    this.state.FocusId1 = 0;
                    let id = this.state.dataList?.AdditionalTrainings.filter((i) => i.Id == 0)
                    if (id.length == 0) {
                        this.state.dataList?.AdditionalTrainings.push({
                            Id: 0,
                            Name: "",
                            TypeId: []
                        })
                    }
                    this.state.dataList?.AdditionalTrainings.sort((a, b) => {
                        return a.Id - b.Id;
                    });
                    this.setState({})
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    put_data = (data, Id) => {
        let apiUrl = API.ACTION_YARDTRAININGS + this.state.YardId + additionalTraining + '/' + Id;
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.dataTableAdditionalTrainings(this.state.searchData)
                    this.setState({ FocusId1: 0, HoverId1: 0, FocusId: 0, HoverId: 0, index: 0 })
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    OpenPopup = (Id) => {
        this.state.deleteId = Id;
        this.setState({})
        window.$("#deletepopup").modal("show")
    }

    DeleteItem = () => {
        window.$("#deletepopup").modal("hide");
        this.deleteopalookdocs(this.state.deleteId)
    }

    deleteopalookdocs = (data) => {
        let apiUrl = API.ACTION_YARDTRAININGS + this.state.YardId + additionalTraining + '/' + data;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "delete",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    let data = {
                        Name: "",
                        PageNumber: 1,
                        PageSize: 100,
                    };
                    this.setState({
                        searchData: data,
                    })
                    this.dataTableAdditionalTrainings(data)
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {

                }
            });
    };

    hoverHeight = (e, i) => {
        let data = $("#actName" + i.Id).val()?.match(/\r?\n/g)?.length ? $("#actName" + i.Id).val()?.match(/\r?\n/g)?.length : 0;
        let data1 = $("#actDesc" + i.Id).val()?.match(/\r?\n/g)?.length ? $("#actDesc" + i.Id).val()?.match(/\r?\n/g)?.length : 0;
        this.state.HoverId = i.Id;
        if (data > data1) {
            this.state.Rows = data + 1;
        }
        else {
            this.state.Rows = data1 + 1;
        }
        this.setState({})
    }

    hoverHeight1 = (e, i) => {
        let data = $("#actName" + i.Id).val()?.match(/\r?\n/g)?.length ? $("#actName" + i.Id).val()?.match(/\r?\n/g)?.length : 0;
        let data1 = $("#actDesc" + i.Id).val()?.match(/\r?\n/g)?.length ? $("#actDesc" + i.Id).val()?.match(/\r?\n/g)?.length : 0;
        this.state.FocusId = i.Id;
        if (data > data1) {
            this.state.Rows1 = data + 1;
        }
        else {
            this.state.Rows1 = data1 + 1;
        }
        this.setState({})
    }

    handleInputAdditionalTraining = (e, str, val, index) => {
        this.setState({
            isOnChange: true,
        })
        if (val == "Name") {
            if (characterValidation(e.target.value) == true) {
                this.state?.dataList?.AdditionalTrainings?.map((i) => (
                    i.Id == str.Id ? i.Title = e.target.value : <></>
                ))
            }
            if (e.target.value != "") {
                let index = this.state.existId.filter(item => item !== str.Id);
                this.setState({
                    existId: index
                })
            }
        }
        this.setState({})
    }

    handleInputAdditionalTrainingBlur = (e, str, val, data, data1) => {
        let dataName = e.target?.value?.trim();
        if (val == "Name") {
            let data = {
                "AddedRoleIds": [],
                "DeletedRoleIds": [],
                "Title": dataName,
                "IsTitleModified": true
            }
            this.put_data(data, str.Id)
        }
    }

    handleTrainingNameChange = (e, str) => {
        this.setState({
            isOnChange: true
        })
        if (characterValidation(e.target.value) == true) {
            this.state.name = e.target.value;
            this.setState({});
        }
        if (e.target.value === "") {
            let index = this.state.existId.filter(item => item !== str.Id);
            this.setState({
                existId: index
            })
        }
    }

    BackPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber - 1;
        this.state.paging = true;
        this.setState({})
        this.dataTableAdditionalTrainings(this.state.searchData)
    }

    NextPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber + 1;
        this.state.paging = true;
        this.setState({})
        this.dataTableAdditionalTrainings(this.state.searchData)
    }

    BackPageCommon = () => {
        this.state.searchCommonData.PageNumber = this.state.searchCommonData.PageNumber - 1;
        this.state.paging = true;
        this.setState({})
        this.dataTableMandatoryTrainings(this.state.searchCommonData)
    }

    NextPageCommon = () => {
        this.state.searchCommonData.PageNumber = this.state.searchCommonData.PageNumber + 1;
        this.state.paging = true;
        this.setState({})
        this.dataTableMandatoryTrainings(this.state.searchCommonData)
    }

    async postDataBlur(e, str, val) {
        this.setState({
            nameError: true,
            // name: e.target.value.trim()
        })
        if (this.state.isOnChange == true) {
            this.setState({
                isOnChange: false
            })
            let dataName = e.target.value.trim();
            if (dataName != "" && ((str.Id == 0 && this.state.typeId?.length > 0) || str.Id != 0)) {
                let url = API.ACTION_YARDTRAININGS + this.state.YardId + API.verifyDuplicate_AdditionalTrainings + dataName;
                try {
                    let response = await axios.get(url);
                    if (response?.data == true) {
                        let index = this.state.existId.filter(item => item !== str.Id);
                        this.setState({
                            existId: index
                        })
                        if (str.Id == 0 && this.state.typeId?.length > 0) {
                            this.trainingChangePostBlur("", str, true);
                        } else if (str.Id != 0) {
                            let data = {
                                "AddedRoleIds": [],
                                "DeletedRoleIds": [],
                                "Title": dataName,
                                "IsTitleModified": true
                            }
                            this.put_data(data, str.Id)
                            this.state.dataList?.YardData?.sort((a, b) => {
                                return a.Id - b.Id;
                            });
                        }
                    } else if (response?.data == false) {
                        let data = [...this.state.existId];
                        data.push(str.Id);
                        this.setState({
                            existId: data
                        })
                    }
                } catch (e) {

                }
            }
            else if (dataName == "") {
                if (str.Id != 0) {
                    let data = {
                        "AddedRoleIds": [],
                        "DeletedRoleIds": [],
                        "Title": dataName,
                        "IsTitleModified": true
                    }
                    this.put_data(data, str.Id)
                    this.setState({ HoverId: 0, index: 0, HoverId1: 0, FocusId1: 0 })
                    this.state.dataList?.YardData?.sort((a, b) => {
                        return a.Id - b.Id;
                    });
                }
                let index = this.state.existId.filter(item => item !== str.Id);
                this.setState({
                    existId: index,
                })
            }
            this.setState({})
        } else {
            this.setState({
                HoverId: 0,
                index: 0
            })
        }
    }

    trainingChangePut = (e, val) => {

        if (this.state.trainingChange == false) {
            localStorage.setItem('ApplicableRoles', JSON.stringify(val?.ApplicableRoles))
            localStorage.setItem('YardRoles', JSON.stringify(val?.YardRoles))
            this.setState({
                trainingChange: true
            })
        }

        let targetApplicableRoles = [];
        let targetYardRoles = [];

        e?.map((r) => (
            r.role === false ? targetApplicableRoles?.push(r) : targetYardRoles?.push(r)
        ))

        let dataArray = [];
        let dataArray1 = [];

        if (targetApplicableRoles?.length > 0 && val?.ApplicableRoles?.length < targetApplicableRoles?.length) {
            targetApplicableRoles?.map((r) => (
                val?.ApplicableRoles?.filter((a) => parseInt(a?.RoleId) == parseInt(r.value?.split(",")[0]))?.length === 0 ?
                    val.ApplicableRoles?.push({
                        RoleId: parseInt(r?.value?.split(",")[0]),
                        RoleName: r?.value?.split(",")[1]
                    }) : ""
            ))
        } else if (val?.ApplicableRoles?.length > 0 && targetApplicableRoles?.length < val?.ApplicableRoles?.length) {
            val?.ApplicableRoles?.map((r) => (
                targetApplicableRoles?.filter((a) => parseInt(a.value?.split(",")[0]) == parseInt(r?.RoleId))?.length === 0 ?
                    (dataArray = val?.ApplicableRoles?.filter(object => {
                        return object.RoleId !== parseInt(r.RoleId)
                    }), val.ApplicableRoles = dataArray) : ""
            ))
        }

        if (targetYardRoles?.length > 0 && val?.YardRoles?.length < targetYardRoles?.length) {
            targetYardRoles?.map((r) => (
                val?.YardRoles?.filter((a) => parseInt(a?.RoleId) == parseInt(r.value?.split(",")[0]))?.length === 0 ?
                    val.YardRoles?.push({
                        RoleId: parseInt(r?.value?.split(",")[0]),
                        RoleName: r?.value?.split(",")[1]
                    }) : ""
            ))
        } else if (val?.YardRoles?.length > 0 && targetYardRoles?.length < val?.YardRoles?.length) {
            val?.YardRoles?.map((r) => (
                targetYardRoles?.filter((a) => parseInt(a.value?.split(",")[0]) == parseInt(r?.RoleId))?.length === 0 ?
                    (dataArray1 = val?.YardRoles?.filter(object => {
                        return object.RoleId !== parseInt(r.RoleId)
                    }), val.YardRoles = dataArray1) : ""
            ))
        }
    }

    trainingChangePutBlur = (e, val) => {

        const targetApplicableRoles = JSON.parse(localStorage.getItem('ApplicableRoles'));
        const targetYardRoles = JSON.parse(localStorage.getItem('YardRoles'));

        let yardAddArray = [];
        let yardRemoveArray = [];
        let commonAddArray = [];
        let commonRemoveArray = [];

        // if (val.Title == "" && (val?.ApplicableRoles?.length == 0 || val?.ApplicableRoles?.length == undefined) && (val?.YardRoles?.length == 0 || val?.YardRoles?.length == undefined)) {
        //     this.deleteopalookdocs(val.Id)
        //     // this.state.index = 0;
        // }

        if (val?.ApplicableRoles?.length == targetApplicableRoles?.length) {
            let data = [];
            val?.ApplicableRoles?.map((r) => (
                targetApplicableRoles?.filter((a) => a.RoleId == parseInt(r?.RoleId))?.length === 0 ?
                    (commonAddArray?.push(parseInt(r?.RoleId)), data.push(r.RoleId)) : ""
            ))
            if (data.length > 0 && data.length < val?.ApplicableRoles?.length) {
                targetApplicableRoles?.map((r) => (
                    val?.ApplicableRoles?.filter((a) => a.RoleId == parseInt(r?.RoleId))?.length === 0 ?
                        (commonRemoveArray?.push(parseInt(r?.RoleId))) : ""
                ))
            }
            if (data.length > 0 && data.length == val?.ApplicableRoles?.length) {
                targetApplicableRoles?.map((r) => (
                    val?.ApplicableRoles?.filter((a) => a.RoleId == parseInt(r?.RoleId))?.length === 0 ?
                        (commonRemoveArray?.push(parseInt(r?.RoleId))) : ""
                ))
            }
        }
        else if (targetApplicableRoles?.length > 0 && val?.ApplicableRoles?.length < targetApplicableRoles?.length) {
            targetApplicableRoles?.map((r) => (
                val?.ApplicableRoles?.filter((a) => parseInt(a?.RoleId) == r.RoleId)?.length === 0 ?
                    (commonRemoveArray?.push(r.RoleId))
                    : ""
            ))
            val?.ApplicableRoles?.map((r) => (
                targetApplicableRoles?.filter((a) => parseInt(a?.RoleId) == r.RoleId)?.length === 0 ?
                    (commonAddArray?.push(r.RoleId))
                    : ""
            ))
        } else if (val?.ApplicableRoles?.length > 0 && targetApplicableRoles?.length < val?.ApplicableRoles?.length) {
            val?.ApplicableRoles?.map((r) => (
                targetApplicableRoles?.filter((a) => a.RoleId == parseInt(r?.RoleId))?.length === 0 ?
                    (commonAddArray?.push(parseInt(r?.RoleId))
                    ) : ""
            ))
            targetApplicableRoles?.map((r) => (
                val?.ApplicableRoles?.filter((a) => a.RoleId == parseInt(r?.RoleId))?.length === 0 ?
                    (commonRemoveArray?.push(parseInt(r?.RoleId))
                    ) : ""
            ))
        }

        if (val?.YardRoles?.length == targetYardRoles?.length) {
            let data = [];
            val?.YardRoles?.map((r) => (
                targetYardRoles?.filter((a) => a.RoleId == parseInt(r?.RoleId))?.length === 0 ?
                    (yardAddArray?.push(parseInt(r?.RoleId)), data.push(r.RoleId)) : ""
            ))
            if (data.length > 0 == data.length < val?.YardRoles?.length) {
                targetYardRoles?.map((r) => (
                    val?.YardRoles?.filter((a) => a.RoleId == parseInt(r?.RoleId))?.length === 0 ?
                        (yardRemoveArray?.push(parseInt(r?.RoleId))) : ""
                ))
            }
            if (data.length > 0 && data.length == val?.YardRoles?.length) {
                targetYardRoles?.map((r) => (
                    val?.YardRoles?.filter((a) => a.RoleId == parseInt(r?.RoleId))?.length === 0 ?
                        (yardRemoveArray?.push(parseInt(r?.RoleId))) : ""
                ))
            }
        }
        else if (targetYardRoles?.length > 0 && val?.YardRoles?.length < targetYardRoles?.length) {
            targetYardRoles?.map((r) => (
                val?.YardRoles?.filter((a) => parseInt(a?.RoleId) == r.RoleId)?.length === 0 ?
                    (yardRemoveArray?.push(r.RoleId))
                    : ""
            ))
            val?.YardRoles?.map((r) => (
                targetYardRoles?.filter((a) => parseInt(a?.RoleId) == r.RoleId)?.length === 0 ?
                    (yardAddArray?.push(r.RoleId))
                    : ""
            ))
        } else if (val?.YardRoles?.length > 0 && targetYardRoles?.length < val?.YardRoles?.length) {
            val?.YardRoles?.map((r) => (
                targetYardRoles?.filter((a) => a.RoleId == parseInt(r?.RoleId))?.length === 0 ?
                    (yardAddArray?.push(parseInt(r?.RoleId))
                    ) : ""
            ))
            targetYardRoles?.map((r) => (
                val?.YardRoles?.filter((a) => a.RoleId == parseInt(r?.RoleId))?.length === 0 ?
                    (yardRemoveArray?.push(parseInt(r?.RoleId))
                    ) : ""
            ))
        }

        let data = {
            "YardAdditionalRoles": {
                "AddedRoleIds": yardAddArray,
                "DeletedRoleIds": yardRemoveArray
            },
            "CommonRoles": {
                "AddedRoleIds": commonAddArray,
                "DeletedRoleIds": commonRemoveArray
            },
            // "Title": this.state.name?.trim()
        }

        if (val?.ApplicableRoles?.length > 0 || val?.YardRoles?.length > 0) {
            this.put_data(data, val.Id)
        }

        localStorage.removeItem('ApplicableRoles')
        localStorage.removeItem('YardRoles')

        this.setState({ FocusId1: 0, trainingChange: false })
    }

    mandatorytrainingChangePost = (e, val) => {

        if (this.state.trainingChange == false) {
            localStorage.setItem('AdditionalRoles', JSON.stringify(val?.AdditionalRoles))
            localStorage.setItem('YardRoles', JSON.stringify(val?.YardRoles))
            this.setState({
                trainingChange: true
            })
        }

        let targetAdditionalRoles = [];
        let targetYardRoles = [];

        e?.map((r) => (
            r.role === false ? targetAdditionalRoles?.push(r) : targetYardRoles?.push(r)
        ))

        let dataArray = [];
        let dataArray1 = [];

        if (targetAdditionalRoles?.length > 0 && val?.AdditionalRoles?.length < targetAdditionalRoles?.length) {
            targetAdditionalRoles?.map((r) => (
                val?.AdditionalRoles?.filter((a) => parseInt(a?.RoleId) == parseInt(r.value?.split(",")[0]))?.length === 0 ?
                    val.AdditionalRoles?.push({
                        RoleId: parseInt(r?.value?.split(",")[0]),
                        RoleName: r?.value?.split(",")[1]
                    }) : ""
            ))
        } else if (val?.AdditionalRoles?.length > 0 && targetAdditionalRoles?.length < val?.AdditionalRoles?.length) {
            val?.AdditionalRoles?.map((r) => (
                targetAdditionalRoles?.filter((a) => parseInt(a.value?.split(",")[0]) == parseInt(r?.RoleId))?.length === 0 ?
                    (dataArray = val?.AdditionalRoles?.filter(object => {
                        return object.RoleId !== parseInt(r.RoleId)
                    }), val.AdditionalRoles = dataArray) : ""
            ))
        }

        if (targetYardRoles?.length > 0 && val?.YardRoles?.length < targetYardRoles?.length) {
            targetYardRoles?.map((r) => (
                val?.YardRoles?.filter((a) => parseInt(a?.RoleId) == parseInt(r.value?.split(",")[0]))?.length === 0 ?
                    val.YardRoles?.push({
                        RoleId: parseInt(r?.value?.split(",")[0]),
                        RoleName: r?.value?.split(",")[1]
                    }) : ""
            ))
        } else if (val?.YardRoles?.length > 0 && targetYardRoles?.length < val?.YardRoles?.length) {
            val?.YardRoles?.map((r) => (
                targetYardRoles?.filter((a) => parseInt(a.value?.split(",")[0]) == parseInt(r?.RoleId))?.length === 0 ?
                    (dataArray1 = val?.YardRoles?.filter(object => {
                        return object.RoleId !== parseInt(r.RoleId)
                    }), val.YardRoles = dataArray1) : ""
            ))
        }

    }

    mandatorytrainingChangePostBlur = (e, val) => {

        const targetAdditionalRoles = JSON.parse(localStorage.getItem('AdditionalRoles'));
        const targetYardRoles = JSON.parse(localStorage.getItem('YardRoles'));

        let yardAddArray = [];
        let yardRemoveArray = [];
        let commonAddArray = [];
        let commonRemoveArray = [];

        if (val?.AdditionalRoles?.length == targetAdditionalRoles?.length) {
            let data = [];
            val?.AdditionalRoles?.map((r) => (
                targetAdditionalRoles?.filter((a) => a.RoleId == parseInt(r?.RoleId))?.length === 0 ?
                    (commonAddArray?.push(parseInt(r?.RoleId)), data.push(r.RoleId)) : ""
            ))
            if (data.length > 0 && data.length < val?.AdditionalRoles?.length) {
                targetAdditionalRoles?.map((r) => (
                    val?.AdditionalRoles?.filter((a) => a.RoleId == parseInt(r?.RoleId))?.length === 0 ?
                        (commonRemoveArray?.push(parseInt(r?.RoleId))) : ""
                ))
            }
            if (data.length > 0 && data.length == val?.AdditionalRoles?.length) {
                targetAdditionalRoles?.map((r) => (
                    val?.AdditionalRoles?.filter((a) => a.RoleId == parseInt(r?.RoleId))?.length === 0 ?
                        (commonRemoveArray?.push(parseInt(r?.RoleId))) : ""
                ))
            }
        }
        else if (targetAdditionalRoles?.length > 0 && val?.AdditionalRoles?.length < targetAdditionalRoles?.length) {
            targetAdditionalRoles?.map((r) => (
                val?.AdditionalRoles?.filter((a) => parseInt(a?.RoleId) == r.RoleId)?.length === 0 ?
                    (commonRemoveArray?.push(r.RoleId))
                    : ""
            ))
            val?.AdditionalRoles?.map((r) => (
                targetAdditionalRoles?.filter((a) => parseInt(a?.RoleId) == r.RoleId)?.length === 0 ?
                    (commonAddArray?.push(r.RoleId))
                    : ""
            ))
        } else if (val?.AdditionalRoles?.length > 0 && targetAdditionalRoles?.length < val?.AdditionalRoles?.length) {
            val?.AdditionalRoles?.map((r) => (
                targetAdditionalRoles?.filter((a) => a.RoleId == parseInt(r?.RoleId))?.length === 0 ?
                    (commonAddArray?.push(parseInt(r?.RoleId))
                    ) : ""
            ))
            targetAdditionalRoles?.map((r) => (
                val?.AdditionalRoles?.filter((a) => a.RoleId == parseInt(r?.RoleId))?.length === 0 ?
                    (commonRemoveArray?.push(parseInt(r?.RoleId))
                    ) : ""
            ))
        }

        if (val?.YardRoles?.length > 0 && val?.YardRoles?.length == targetYardRoles?.length) {
            let data = [];
            val?.YardRoles?.map((r) => (
                targetYardRoles?.filter((a) => a.RoleId == parseInt(r?.RoleId))?.length === 0 ?
                    (yardAddArray?.push(parseInt(r?.RoleId)), data.push(r.RoleId)) : ""
            ))
            if (data.length > 0 && data.length < val?.YardRoles?.length) {
                targetYardRoles?.map((r) => (
                    val?.YardRoles?.filter((a) => a.RoleId == parseInt(r?.RoleId))?.length === 0 ?
                        (yardRemoveArray?.push(parseInt(r?.RoleId))) : ""
                ))
            }
            if (data.length > 0 && data.length == val?.YardRoles?.length) {
                targetYardRoles?.map((r) => (
                    val?.YardRoles?.filter((a) => a.RoleId == parseInt(r?.RoleId))?.length === 0 ?
                        (yardRemoveArray?.push(parseInt(r?.RoleId))) : ""
                ))
            }
        }
        else if (targetYardRoles?.length > 0 && val?.YardRoles?.length < targetYardRoles?.length) {
            targetYardRoles?.map((r) => (
                val?.YardRoles?.filter((a) => parseInt(a?.RoleId) == r.RoleId)?.length === 0 ?
                    (yardRemoveArray?.push(r.RoleId))
                    : ""
            ))
            val?.YardRoles?.map((r) => (
                targetYardRoles?.filter((a) => parseInt(a?.RoleId) == r.RoleId)?.length === 0 ?
                    (yardAddArray?.push(r.RoleId))
                    : ""
            ))
        } else if (val?.YardRoles?.length > 0 && targetYardRoles?.length < val?.YardRoles?.length) {
            val?.YardRoles?.map((r) => (
                targetYardRoles?.filter((a) => a.RoleId == parseInt(r?.RoleId))?.length === 0 ?
                    (yardAddArray?.push(parseInt(r?.RoleId))
                    ) : ""
            ))
            targetYardRoles?.map((r) => (
                val?.YardRoles?.filter((a) => a.RoleId == parseInt(r?.RoleId))?.length === 0 ?
                    (yardRemoveArray?.push(parseInt(r?.RoleId))
                    ) : ""
            ))
        }

        let data = {
            "YardAdditionalRoles": {
                "AddedRoleIds": yardAddArray,
                "DeletedRoleIds": yardRemoveArray
            },
            "CommonRoles": {
                "AddedRoleIds": commonAddArray,
                "DeletedRoleIds": commonRemoveArray
            }
        }

        localStorage.removeItem('AdditionalRoles')
        localStorage.removeItem('YardRoles')

        this.put_datamandatory(data, val.Id)
        this.setState({ FocusIdCommon: 0, HoverIdCommon: 0, trainingChange: false })
    }

    put_datamandatory = (data, Id) => {
        let apiUrl = API.ACTION_YARDTRAININGS + this.state.YardId + yardMandatoryTraining + '/' + Id;
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.dataTableMandatoryTrainings(this.state.searchCommonData)
                if (response?.status === 200) {
                    this.setState({ FocusId1: 0, HoverId1: 0, FocusId: 0, HoverId: 0, index: 0 })
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    setDefaultTrainings = (array, array1) => {

        let data = [];

        this.state.trainingsOptions?.map((r) => (
            array?.filter((a) => a.RoleId == parseInt(r.value?.split(',')[0]) && r.role === false)?.length > 0 ? data.push(r) : ""
        ))
        this.state.trainingsOptions?.map((r) => (
            array1?.filter((a) => a.RoleId == parseInt(r.value?.split(',')[0]) && r.role === true)?.length > 0 ? data.push(r) : ""
        ))
        return data;
    }

    setOptions = (data, data1, data2) => {
        let roleId = [];
        if (data.length > 0) {
            data?.map((r) => (
                roleId.push(r.RoleId)
            ))
        }
        let array = [];
        this.state.trainingsOptions?.map((r) => (
            r.role == true ? array.push(r) : roleId.includes(parseInt(r.value?.split(',')[0])) == false && r.role == false ? array.push(r) : ""
        ))

        return array
    }

    setDefaultTrainingsMandatory = (array, array1) => {

        let data = [];

        this.state.trainingsOptions?.map((r) => (
            array?.filter((a) => a.RoleId == parseInt(r.value?.split(',')[0]) && r.role === false)?.length > 0 ? data.push(r) : ""
        ))
        this.state.trainingsOptions?.map((r) => (
            array1?.filter((a) => a.RoleId == parseInt(r.value?.split(',')[0]) && r.role === true)?.length > 0 ? data.push(r) : ""
        ))
        return data;
    }

    trainingChangePost = (e, val) => {

        this.setState({
            typeId: e,
        })

        if (e?.length > 0 || (e?.length == 0 && this.state.name != "")) {
            this.setState({
                nameError: true
            })
        } else {
            this.setState({
                nameError: false
            })
        }
    }

    async trainingChangePostBlur(e, val, data) {

        let yardAddArray = [];
        let yardRemoveArray = [];
        let commonAddArray = [];
        let commonRemoveArray = [];

        if (this.state.typeId?.length > 0) {
            this.state.typeId?.map((r) => (
                r.role == true ? yardAddArray.push(parseInt(r.value?.split(",")[0]))
                    : commonAddArray.push(parseInt(r.value?.split(",")[0]))
            ))
        }
        if (data == true) {
            let data = {
                "YardAdditionalRoles": {
                    "AddedRoleIds": yardAddArray,
                    "DeletedRoleIds": yardRemoveArray
                },
                "CommonRoles": {
                    "AddedRoleIds": commonAddArray,
                    "DeletedRoleIds": commonRemoveArray
                },
                "Title": this.state.name?.trim()
            }
            this.post_data(data)
        } else {
            if (this.state.name?.trim() != "" && this.state.typeId?.length > 0) {
                let url = API.ACTION_YARDTRAININGS + this.state.YardId + API.verifyDuplicate_AdditionalTrainings + this.state.name?.trim();
                try {
                    let response = await axios.get(url);
                    if (response?.data == true) {
                        let index = this.state.existId.filter(item => item !== val.Id);
                        this.setState({
                            existId: index
                        })
                        let data = {
                            "YardAdditionalRoles": {
                                "AddedRoleIds": yardAddArray,
                                "DeletedRoleIds": yardRemoveArray
                            },
                            "CommonRoles": {
                                "AddedRoleIds": commonAddArray,
                                "DeletedRoleIds": commonRemoveArray
                            },
                            "Title": this.state.name?.trim()
                        }
                        this.post_data(data)
                    } else if (response?.data == false) {
                        let data = [...this.state.existId];
                        data.push(val.Id);
                        this.setState({
                            existId: data
                        })
                    }
                } catch (e) {

                }
            }
        }
        this.setState({ FocusId1: 0 })
    }

    handleInputChangeCommon = (e, str) => {
        this.state?.dataListCommon?.MandatoryTrainings?.map((i) => (
            i.Id == str.Id ? i.DisplayName = e.target.value : <></>
        ))
        this.setState({})
    }

    render() {
        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row border-bottom w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={() => this.sidebar()} >
                                            <ListItemText id="Yardroles" className='  textNaviIcon' primary="Yard Documents" />
                                            <NavigateNextIcon id="Yardroles1" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5">
                                    {/* <h4>Additional Trainings&nbsp;<img src={yardIcon} /></h4> */}
                                    <h4>Additional Trainings</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto" id="trainingsPage" style={{ overflowX: "hidden", backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {/* Additional Trainings */}

                    <div className="row" style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        <div className="row px-3">
                            <div className="col-10 p-2" id="additionalTrainings">
                                {this.state.isMobile ? <></> : <h6>Additional Trainings</h6>}
                            </div>
                        </div>
                        <div className="col-12 col-lg-12 col-md-12 col-sm-12 col-xl-12">
                            <div className="table-responsive mb-3" style={{ width: "100%" }}>
                                <table id="" className="table table-borderless border-top border-bottom border-left border-right">
                                    <thead>
                                        <tr className="table-active">
                                            <th className="border-top border-right border-left" width="49%" style={{ minWidth: '49%', maxWidth: '49%' }}><span className="spandoc-thead">Training Title</span></th>
                                            <th className="border-top border-right" width="48%" style={{ minWidth: '48%', maxWidth: '48%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Applicable Roles</span></th>
                                            <th className="border-top border-right" onClick={() => this.setState({ content: !this.state.content })} width="3%" style={{ minWidth: '3%', maxWidth: '3%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Action</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state?.dataList?.AdditionalTrainings && this.state?.dataList?.AdditionalTrainings?.map((i, index) => (
                                            i.Id != 0 ?
                                                <tr className="border-top">
                                                    <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left span-height align-middle`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                        <div className={this.state.isDisabled ? "border-bg-none" : (this.state.HoverId == i.Id || this.state.index == i.Id || i.Title == "" || this.state.existId?.includes(i.Id) == true) ? "border-bg" : "border-bg-none"}>
                                                            <CssTextFieldRow
                                                                multiline
                                                                fullWidth
                                                                variant="outlined"
                                                                type="text"
                                                                id={"actName" + i.Id}
                                                                disabled={this.state.isDisabled}
                                                                onMouseEnter={(e) => this.setState({ HoverId: i.Id })}
                                                                onMouseLeave={(e) => this.setState({ HoverId: 0 })}
                                                                // style={{ height: $("#actName" + i.Id).outerHeight() > $("#actDesc" + i.Id).outerHeight() ? $("#actName" + i.Id).outerHeight() + 13 : $("#actDesc" + i.Id).outerHeight() + 13, marginTop: "-3px" }}
                                                                style={{ minHeight: "39px", marginTop: "-3px" }}
                                                                onFocus={(e) => this.setState({ index: i.Id })}
                                                                onChange={(e) => this.handleInputAdditionalTraining(e, i, 'Name', index)}
                                                                onBlur={(e) => this.postDataBlur(e, i, 'Name', i.ApplicableRoles, i.YardRoles)}
                                                                value={i.Title && i.Title}
                                                                InputProps={{
                                                                    className: `border-radius padding-space-trainings spandoc-tbody ${classes.inputfieldAlign}`
                                                                }} />
                                                        </div>
                                                        {/* } */}
                                                        {(i.Title == "") ?
                                                            <span className="pt-5" style={{ color: '#DD0000' }}>Training title is required</span> : <></>}
                                                        {(i.Title?.trim() != "" && this.state.existId?.includes(i.Id) == true) ?
                                                            <span className="pt-5 red-color">Training title is already exist</span> : <></>}
                                                    </td>
                                                    <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left align-middle`} style={{ minWidth: '49%', maxWidth: '49%' }}
                                                        onMouseEnter={(e) => this.setState({ HoverId1: i.Id })}
                                                        onMouseLeave={(e) => this.setState({ HoverId1: 0 })}
                                                    >

                                                        {this.state.isDisabled == true ?
                                                            <div className="">
                                                                {i?.ApplicableRoles?.map((r, ind) => (
                                                                    ind == 0 ? r.RoleName : ", " + r.RoleName
                                                                ))}
                                                                {i?.YardRoles?.map((r, ind) => (
                                                                    (ind == 0 && i?.ApplicableRoles?.length == 0) ? r.RoleName : ", " + r.RoleName
                                                                ))}
                                                            </div> :
                                                            (this.state.HoverId1 == i.Id || this.state.FocusId1 == i.Id) || ((i?.ApplicableRoles?.length == 0 || i?.ApplicableRoles?.length == undefined) && (i?.YardRoles?.length == 0 || i?.YardRoles?.length == undefined)) ?
                                                                <div
                                                                >
                                                                    <Select
                                                                        options={this.state.trainingsOptions || []}
                                                                        value={this.setDefaultTrainings(i.ApplicableRoles, i.YardRoles)}
                                                                        placeholder=""
                                                                        classNamePrefix={"trainingsSelect"}
                                                                        menuPosition="fixed"
                                                                        menuPlacement="auto"
                                                                        isMulti={true}
                                                                        isSearchable={true}
                                                                        // styles={customStyles}
                                                                        onChange={(e) => this.trainingChangePut(e, i)}
                                                                        onBlur={(e) => this.trainingChangePutBlur(e, i)}
                                                                        onFocus={(e) => this.setState({ FocusId1: i.Id })}
                                                                    // onBlur={(e) => this.setState({ FocusId1: 0 })}
                                                                    />
                                                                    {((i?.ApplicableRoles?.length == 0 || i?.ApplicableRoles?.length == undefined) && (i?.YardRoles?.length == 0 || i?.YardRoles?.length == undefined)) ?
                                                                        <span className="pt-5" style={{ color: '#DD0000' }}>Atleast one applicable role is required</span> : <></>}
                                                                </div> :
                                                                <div className="">
                                                                    {i?.ApplicableRoles?.map((r, ind) => (
                                                                        ind == 0 ? r.RoleName : ", " + r.RoleName
                                                                    ))}
                                                                    {i?.YardRoles?.map((r, ind) => (
                                                                        (ind == 0 && i?.ApplicableRoles?.length == 0) ? r.RoleName : ", " + r.RoleName
                                                                    ))}
                                                                </div>}
                                                    </td>
                                                    <td className="align-middle text-center border-right"><img src={Delete} className={this.state.isDisabled ? "img-disabled" : "cursorPointer"} onClick={() => { this.OpenPopup(i.Id) }} /></td>
                                                </tr> : <></>
                                        ))}
                                        {this.state?.dataList?.AdditionalTrainings && this.state?.dataList?.AdditionalTrainings.map((i) => (
                                            i.Id == 0 ?
                                                <tr className="border-top">
                                                    <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left align-middle`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                        <CssTextFieldLast
                                                            multiline
                                                            fullWidth
                                                            variant="outlined"
                                                            type="text"
                                                            id="actName"
                                                            disabled={this.state.isDisabled}
                                                            onChange={(e) => this.handleTrainingNameChange(e, i, 'Name')}
                                                            onBlur={(e) => this.postDataBlur(e, i, 'Name')}
                                                            value={this.state.name}
                                                            InputProps={{
                                                                className: `border-radius padding-space-trainings spandoc-tbody ${classes.inputfieldAlign}`
                                                            }} />
                                                        {((this.state.name.trim() == "" && this.state.typeId?.length > 0 && this.state.nameError == true)) ?
                                                            <span className="pt-5" style={{ color: '#DD0000' }}>Training title is required</span> : <></>}
                                                        {(this.state.name.Name?.trim() != "" && this.state.existId?.includes(i.Id) == true) ?
                                                            <span className="pt-5 red-color">Training title is already exist</span> : <></>}
                                                    </td>
                                                    <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                        <Select
                                                            options={this.state.trainingsOptions || []}
                                                            disabled={this.state.isAccess == false ? true : false}
                                                            placeholder=""
                                                            classNamePrefix={"trainingsSelect"}
                                                            menuPosition="fixed"
                                                            menuPlacement="auto"
                                                            isMulti={true}
                                                            isSearchable={true}
                                                            onChange={(e) => this.trainingChangePost(e, i)}
                                                            onBlur={(e) => this.trainingChangePostBlur(e, i)}
                                                            onFocus={(e) => this.setState({ FocusId1: i.Id })}
                                                        // onBlur={(e) => this.setState({ FocusId1: 0 })}
                                                        />
                                                        {((this.state.name.trim() != "" && this.state.typeId == 0 && this.state.nameError == true)) ?
                                                            <span className="pt-5" style={{ color: '#DD0000' }}>Atleast one applicable role is required</span> : <></>}
                                                    </td>
                                                    <td className="align-middle text-center border-right">
                                                        {/* {(i.Name.trim() != "" || (i.Name.trim() == "" && this.state.nameError == true)) ? <img src={Delete} className="cursorPointer" /> : <></>} */}
                                                    </td>
                                                </tr> : <></>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className={`${classes.paginationNormal}`} id="mandatoryTrainingsScroll">
                        <div className={`${classes.paginationItem}`}>
                            {this.state.searchData.PageNumber == 1 ? <></> :
                                <ArrowBackIcon className={classes.arrow} onClick={() => this.BackPage()} />}
                            <span className="pl-2 pr-2">Page {this.state.searchData.PageNumber}</span>
                            {(this.state.searchData.PageNumber == this.state.dataList?.Pagination?.PageCount) || (this.state.dataList?.Pagination?.PageCount == 0) ? <></> :
                                <ArrowForwardIcon className={classes.arrow} onClick={() => this.NextPage()} />}
                        </div>
                    </div>

                    {/* Mandatory Trainings */}

                    <div className="row" style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        <div className="row px-3">
                            <div className="col-12 p-2 mt-3">
                                {/*this.state.isMobile ? <></> : */<h6>Mandatory Trainings</h6>}
                            </div>
                        </div>
                        <div className="col-12 col-lg-12 col-md-12 col-sm-12 col-xl-12">
                            <div className="table-responsive mb-3" style={{ width: "100%" }}>
                                <table id="" className="table table-borderless border-top border-bottom border-left border-right">
                                    <thead>
                                        <tr className="table-active">
                                            <th className="border-top border-right border-left" width="33%" style={{ minWidth: '33%', maxWidth: '33%' }}><span className="spandoc-thead">Training Title</span></th>
                                            <th className="border-top border-right" width="33%" style={{ minWidth: '33%', maxWidth: '33%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Predefined Roles</span></th>
                                            <th className="border-top border-right" width="34%" style={{ minWidth: '34%', maxWidth: '34%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Additional Roles</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state?.dataListCommon?.MandatoryTrainings && this.state?.dataListCommon?.MandatoryTrainings?.map((i, index) => (
                                            i.Id != 0 ?
                                                <tr className="border-top">
                                                    <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left align-middle span-height`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                        <span>{i?.Title}</span>
                                                    </td>
                                                    <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left align-middle`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                        {i?.PredefinedRoles?.map((r, ind) => (
                                                            ind == 0 ? r.RoleName : ", " + r.RoleName
                                                        ))}
                                                    </td>
                                                    <td className="align-middle border-right"
                                                        onMouseEnter={(e) => this.setState({ HoverIdCommon: i.Id })}
                                                        onMouseLeave={(e) => this.setState({ HoverIdCommon: 0 })}>
                                                        {this.state.isDisabled == true ?
                                                            <div className="">
                                                                {i?.AdditionalRoles?.map((r, ind) => (
                                                                    ind == 0 ? r.RoleName : ", " + r.RoleName
                                                                ))}
                                                                {i?.YardRoles?.map((r, ind) => (
                                                                    (ind == 0 && i?.AdditionalRoles?.length == 0) ? r.RoleName : ", " + r.RoleName
                                                                ))}
                                                            </div> :
                                                            (this.state.HoverIdCommon == i.Id || this.state.FocusIdCommon == i.Id) ?
                                                                <Select
                                                                    options={this.setOptions(i?.PredefinedRoles, i.AdditionalRoles, i.YardRoles) || []}
                                                                    // disabled={this.state.isAccess == false ? true : false}
                                                                    placeholder=""
                                                                    value={this.setDefaultTrainingsMandatory(i.AdditionalRoles, i.YardRoles)}
                                                                    classNamePrefix={"trainingsSelect"}
                                                                    menuPosition="fixed"
                                                                    menuPlacement="auto"
                                                                    isMulti={true}
                                                                    isSearchable={true}
                                                                    onChange={(e) => this.mandatorytrainingChangePost(e, i)}
                                                                    onFocus={(e) => this.setState({ FocusIdCommon: i.Id })}
                                                                    onBlur={(e) => this.mandatorytrainingChangePostBlur(e, i)}
                                                                // onBlur={(e) => this.setState({ FocusIdCommon: 0 })}
                                                                /> :
                                                                <div className="">
                                                                    {i?.AdditionalRoles?.map((r, ind) => (
                                                                        ind == 0 ? r.RoleName : ", " + r.RoleName
                                                                    ))}
                                                                    {i?.YardRoles?.map((r, ind) => (
                                                                        (ind == 0 && i?.AdditionalRoles?.length == 0) ? r.RoleName : ", " + r.RoleName
                                                                    ))}
                                                                </div>}
                                                        {/* </div> */}
                                                    </td>
                                                </tr> : <></>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className={`${classes.paginationNormal}`}>
                        <div className={`${classes.paginationItem}`}>
                            {this.state.searchCommonData.PageNumber == 1 ? <></> :
                                <ArrowBackIcon className={classes.arrow} onClick={() => this.BackPageCommon()} />}
                            <span className="pl-2 pr-2">Page {this.state.searchCommonData.PageNumber}</span>
                            {(this.state.searchCommonData.PageNumber == this.state.dataListCommon?.Pagination?.PageCount) || (this.state.dataListCommon?.Pagination?.PageCount == 0) ? <></> :
                                <ArrowForwardIcon className={classes.arrow} onClick={() => this.NextPageCommon()} />}
                        </div>
                    </div>

                    <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5></div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem()}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#deletepopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(YardTrainings))
);
